import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStore } from '@common/data-models/data-store/data-store';
import { ServiceCollectionRecord } from '@common/data-models/service/service-collection-record';
import { ServiceResponse } from '@common/data-models/service/service-response';

import { NomWebServicesJson } from './nom-web-services-json';
import { VisualStateService } from './visual-state-service';

@Injectable({ providedIn: 'root' })
export class UserLocationService {
    constructor(
        public nomWebServicesJson: NomWebServicesJson,
        public visualStateService: VisualStateService
    ) {}

    public async getUserLocationResources(database: string, locations: Array<string>, filterQuery: string): Promise<ServiceResponse<Map<string, StorytellingUserRecord>>> {
        const results: Map<string, StorytellingUserRecord> = new Map();
        let response: HttpResponse<any> = null;
        try {
            response = await this.nomWebServicesJson.get('/api/ResourceLocations', {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                }),
                responseType: 'json',
                params: {
                    database,
                    path: locations.join(';'),
                    fq: filterQuery,
                },
                observe: 'response',
            });
            if (response) {
                const respObj = response.body;
                for (const p of respObj.SearchResults) {
                    const serviceCollectionRecord: ServiceCollectionRecord = ServiceCollectionRecord.instance(p);
                    const userRecord = this.nomWebServicesJson.convertor.fromServiceUserRecord(serviceCollectionRecord);
                    results.set(userRecord.Guid, userRecord);
                }
                // TODO RTU
                locations.forEach(loc => DataStore.subscribeForPathUpdates(database, `${loc}RS`));
            }
        } catch (error) {
            this.nomWebServicesJson.showErrorModal({
                message: 'Unable to get resource locations',
                detailMessage: `Unable to get resource locations. \n\rStackTrace: NomWebServicesJson.getUserLocationResources(); \n\rError: ${error}`,
            });
            return new ServiceResponse<Map<string, StorytellingUserRecord>>(false, `Unable to get user locations ${error.toString()}`);
        }
        return new ServiceResponse<Map<string, StorytellingUserRecord>>(true, results);
    }
}
